import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4163 14.1731C17.4163 17.4443 15.8268 19.25 10.9997 19.25C6.17251 19.25 4.58301 17.4443 4.58301 14.1731C4.58301 9.20954 6.17251 8.25 10.9997 8.25C15.8268 8.25 17.4163 9.20954 17.4163 14.1731Z",
			stroke: "#6E7A90",
			strokeWidth: 1.46667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 11V12.8333",
			stroke: "#6E7A90",
			strokeWidth: 1.46667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.33301 8.25V6.41667C7.33301 4.125 9.16634 2.75 10.9997 2.75C12.833 2.75 14.6663 4.125 14.6663 6.41667V8.25",
			stroke: "#6E7A90",
			strokeWidth: 1.46667,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
